import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2FD9933D-7226-4745-B5DB-C8E6245FB170
 * name plus-thick
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-thick.svg
 * tags
 * - Math 
 */
export const PlusThickIcon = createSvgIcon(<><path d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" /></>, 'PlusThickIcon');
export default PlusThickIcon